module.exports = __webpack_public_path__ + "static/media/avocado-icon.6a9bde97.png";